import { render, staticRenderFns } from "./leaseaManagement_item.vue?vue&type=template&id=16bf2f0a"
import script from "./leaseaManagement_item.vue?vue&type=script&lang=js"
export * from "./leaseaManagement_item.vue?vue&type=script&lang=js"
import style0 from "./leaseaManagement_item.vue?vue&type=style&index=0&id=16bf2f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports